<template>
	<div class='credit-card-info'>
		<h6 class='sub-header primary-color'>
			<FormRadio v-model="card_selected" val="Card" @update='setMethod'>
				<span class='payment-option-selection primary-color font-weight-normal'>{{getText('PayWithCard')}}</span>
			</FormRadio>
		</h6>

		<div class='row'>
			<div class='col-xs-12 col-lg-6'>
				<FormInput :title="getText('CardNumber')" placeholder='4111...' name='cc-number' autocomplete="cc-number" v-model.lazy="card_number" />
			</div>
			<div class='col-xs-12 col-sm-6 col-lg-3'>
				<FormSelect :title="getText('CardType')" v-model.lazy='Type' :options="get_payment_types"/>
			</div>
			<div class='col-xs-12 col-sm-6 col-lg-3'>
				<FormInput :title="getText('SecurityCode')" placeholder='773' maxlength="4" name='cc-csc' autocomplete="cc-csc" v-model.lazy="VerificationCode" />
			</div>
		</div>

		<div class='row'>
			<div class='col-xs-12 col-lg-6'>
				<FormInput :title="getText('CardholderName')" placeholder='John Smith' name="cc-name" autocomplete="cc-name" v-model.lazy="holder_name" />
			</div>
			<div class='col-xs-12 col-sm-6 col-lg-3'>
				<FormSelect :title="getText('ExpirationMonth')" default_text='Select Month' name='cc-exp-month' autocomplete="cc-exp-month" :options="card_month" v-model.lazy="Expiry.Month" />
			</div>
			<div class='col-xs-12 col-sm-6 col-lg-3'>
				<FormSelect :title="getText('ExpirationYear')" default_text='Select Year' name='cc-exp-year' autocomplete="cc-exp-year" :options="card_year" v-model.lazy="Expiry.Year" />
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.credit-card-info{
		width: 100%;
	}
	.payment-option-selection{
		padding-left: 5px;
		font-weight: 500;
		font-family: "proximanova-regular";
		position: relative;
		top: -2px;
	}
</style>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

// Language / Localization
import LanguageService from "@/common/language.service";

import {
	SET_PAYMENT_METHOD
} from "@/store/mutations.type";

import FormInput from "@/components/form_elements/FormInput";
import FormNumber from "@/components/form_elements/FormNumber";
import FormSelect from "@/components/form_elements/FormSelect";
import FormRadio from "@/components/form_elements/FormRadio";

export default {
	name: "CardDetails",
	components: {
		FormInput,
		FormSelect,
		FormNumber,
		FormRadio
	},
	props: {
		value: Object
	},
	data(){
		//@TODO: Clear this once done testing cards
		return {
			Type: 'VISA',
			holder_name: '',//'test',
			card_number: '',//'5454545454545454', //'4917610000000000',
			VerificationCode: '',//'737',
			Expiry: {
				Year: '',//"2020",
				Month: '',//"10"
			}
		};
	},
	beforeMount(){
		//Preset appropriate values based on input
		this.Type = "";

		// First we want to check what current method is. Set type if applicable
		if(this.payment_method().Id === undefined) return;
		this.Type = this.payment_method().Id;

		// If we have collected data already, Preload it
		if(this.value === undefined) return;
		if(this.value.Name !== undefined && this.value.Name.trim() != "" && this.value.Name !== null){
			this.holder_name = this.value.Name;
		}
		if(this.value.Number !== undefined && this.value.Number.trim() != "" && this.value.Number !== null){
			this.card_number = this.value.Number;
		}
		if(this.value.VerificationCode !== undefined && this.value.VerificationCode.trim() != "" && this.value.VerificationCode !== null){
			this.VerificationCode = this.value.VerificationCode;
		}
		if(this.value.Expiry !== undefined && this.value.Expiry != {}){
			this.Expiry = this.value.Expiry;
		}

		this.setMethod();
	},
	watch: {
		// On change, try to set payment method
		card_details: function(data){
			this.setMethod();
		},
		Type: function(data){
			this.setMethod();
		}
	},
	computed: {
		card_selected: {
			get(){
				// We want this variable to read from the global store
				return this.payment_method().Class;
			},
			set(data){
				// Should NOT write to the store directly. The setMethod call will hit it if conditions are right
				this.setMethod();
			}
		},
		card_details(){
			// Card Details format
			return {
				Name: this.holder_name,
				"Number": this.card_number,
				VerificationCode: this.VerificationCode,
				Expiry: {
					Year: this.Expiry.Year,
					Month: this.Expiry.Month
				}
			};
		},
		card_year(){
			// Generate card year expiry select options
			var current_year = new Date().getFullYear();
			var list = [];
			for(var i = current_year;i<=(current_year+25);i++){
				list.push(i);
			}
			return list.map(x => ({ id: x, value: x }));
		},
		card_month(){
			// Generate card month expiry select options
			var list = [];
			for(var i = 1;i<13;i++){
				list.push(i.pad(2));
			}
			return list.map(x => ({ id: x, value: x }));
		},
		get_card_methods(){
			// Filter away all non card payment methods
			return this.paymentMethods().filter(x => (x.Class == "Card"));
		},
		get_payment_types(){
			// Take all card payment methods and convert them to select options
			return this.get_card_methods.map(x => ({ id: x.Id, value: x.Name}));
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		setMethod(method){
			// Check if we have changed card type
			if(this.Type === undefined || this.Type == ""){
				Promise.all([
					store.commit(SET_PAYMENT_METHOD, { Id: "", Class: "Card", Name: ""})
				]).then(()=>{
					this.update();
				});
				return;
			}

			// Grab the selected Card Payment method
			var selected = this.get_card_methods.filter(x => (x.Id == this.Type));
			if(selected.length != 1) return;

			// Set method in Store
			Promise.all([
				store.commit(SET_PAYMENT_METHOD, selected[0])
			]).then(()=>{
				this.update();
			});
		},
		update() {
			// Push up collected data
			this.$emit('input', this.card_details);
		},
		...mapGetters(["payment_method", "paymentMethods"])
	}
}
</script>
